module.exports = __webpack_public_path__ + "img/label_leed_platinum.556087af.png";